import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "./index";

const select = (state: RootState) => state;

const selectCommon = (select: RootState) => select.common;
const selectSchedule = (select: RootState) => select.schedule;
const selectJournal = (select: RootState) => select.journal;
const selectProfile = (select: RootState) => select.profile;
const selectPlans = (select: RootState) => select.plans;
const selectPrintJournal = (select: RootState) => select.printJournal;
const selectRup = (select: RootState) => select.rup;
const selectLibrary = (select: RootState) => select.library;
const selectPsychologist = (select: RootState) => select.psychologist;

//entrant
const selectAdmission = (select: RootState) => select.admission;
const selectExam = (select: RootState) => select.exam;

export const selectStore = createSelector(
  selectCommon,
  selectSchedule,
  selectJournal,
  selectProfile,
  selectPlans,
  selectRup,
  selectPrintJournal,
  selectExam,
  selectAdmission,
  selectLibrary,
  selectPsychologist,
    (
      common,
      schedule,
      journal,
      profile,
      plans,
      rup,
      printJournal,
      exam,
      admission,
      library,
      psychologist
    ) => ({
      common: common,
      schedule,
      journal,
      profile,
      plans,
      rup,
      printJournal,
      exam,
      admission,
      library,
      psychologist
    }));
